const translation = {
  tags: {
    weather: 'Wetter',
    social: 'Sozial',
    image: 'Bild',
    education: 'Bildung',
    travel: 'Reise',
    agent: 'Agent',
    design: 'Entwurf',
    finance: 'Finanzieren',
    search: 'Suchen',
    medical: 'Medizinisch',
    business: 'Geschäft',
    news: 'Nachrichten',
    videos: 'Videos',
    other: 'Andere',
    entertainment: 'Unterhaltung',
    utilities: 'Versorgungswirtschaft',
    productivity: 'Produktivität',
  },
  searchTags: 'Such-Tags',
  allTags: 'Alle Schlagwörter',
}

export default translation
